module.exports = __webpack_public_path__ + "static/media/editPenBlack.53e6ecb6.svg";